'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Service est actuellement indisponible, veuillez réessayer plus tard.',
    NEED_ACTIVE: "Votre compte {{account}} utilise ce site pour la première fois. Veuillez {{activeLink}} finaliser l'activation et revenir à cette page pour continuer les opérations.",
    GOTO_ACTIVE: 'Activer',
    NOT_ACTIVED: "Le compte n'a pas été activé. Veuillez {{activeLink}} finaliser l'activation",
    COMPLETE_ACTIVE: "Confirmer l'activation ",
    FORBID_ACTIVE: 'Le compte est indisponible sur AliExpress !',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Veuillez-vous connecter avec un autre compte',
    ACTIVE_PAGE: "Aller à la page d'activation du compte"
};